import { Trans } from '@lingui/macro';
import SupportManGradientGraphic from './images/support-man-gradient.svg';

interface Props {
    children: string | JSX.Element;
}

export default function ContactMeHelp({ children }: Props) {
    return (
        <>
            <div className="mb-16">{children}</div>
            <div className="flex flex-col justify-center items-center">
                <img src={SupportManGradientGraphic} className="mb-4 h[207px] w[242px]" />
                <strong className="mb-4">
                    <Trans>We'd love to help! Fill out the form on the tab 'Lager af Rackbeat'</Trans>
                </strong>
                <p className="mb-4">
                    <Trans>Didn't get redirected automatically? Check your browser for a tab called 'Lager af Rackbeat'</Trans>
                </p>
            </div>
        </>
    );
}
